import { map } from 'lodash';

import SocialPlugin from 'hb-react/frontoffice/components/SocialPlugin';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

import TopicHomeGeneralInfosContainer from '../TopicHomeGeneralInfosContainer';

import style from './index.module.scss';

const TopicSideBar = ({ topic }) => {
  const { currentNetwork } = useDefaultAppContexts();

  const socialProps = {
    height: 500,
    socials: map(topic.social_plugins, (plugin) => {
      plugin.pluginType = plugin.plugin_type;

      return plugin;
    }),
  };

  const usersCanAcceptCookiesForWidgets =
    currentNetwork?.features?.cookies?.config?.cookies_banner_v2_enabled &&
    currentNetwork?.features?.cookies?.config?.display_cookie_agreement;

  return (
    <div className={style['side-container']}>
      <TopicHomeGeneralInfosContainer topic={topic} />
      <SocialPlugin
        {...socialProps}
        usersCanAcceptCookiesForWidgets={usersCanAcceptCookiesForWidgets}
      />
    </div>
  );
};

export default TopicSideBar;
